import React, { useState } from 'react';
import '../../styles/loginPage.css';
import '../../styles/register.css';
import { notify } from '../toast';
import useAxiosPrivate from '../../api/useAxiosPrivate';
import Modal from 'react-modal';
import imageCompression from 'browser-image-compression';

const HIERARCHY_LEVELS = [
    { value: 'village_cluster', label: 'Village Cluster' },
    { value: 'mandal_officer', label: 'Mandal Officer' },
    { value: 'district_officer', label: 'District Officer' },
    { value: 'area_manager', label: 'Area Manager' },
];

const ROLE_LEVEL = {
    village_cluster: 1,
    mandal_officer: 2,
    district_officer: 3,
    area_manager: 4,
    admin: 5
};

const EmployeeRegister = ({ role }) => {
    const [name, setName] = useState('');
    const [gender, setGender] = useState('');
    const [email, setEmail] = useState('');
    const [mobile, setMobile] = useState('');
    const [parent, setParent] = useState('');
    const [address, setAddress] = useState('');
    const [educationQualification, setEducationQualification] = useState('');
    const [aadhaar, setAadhaar] = useState('');
    const [pan, setPan] = useState('');
    const [bank, setBank] = useState('');
    const [ifsc, setIfsc] = useState('');
    const [hierarchyLevel, setHierarchyLevel] = useState('village_cluster');

    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const [employeeId, setEmployeeId] = useState('');
    const [openPhotoUpload, setOpenPhotoUpload] = useState(false);

    const axiosPrivate = useAxiosPrivate();

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');

        if (!validateMobile(mobile) || mobile.length !== 10) {
            return setError('Invalid mobile number');
        } else {
            try {
                setLoading(true);
                const response = await axiosPrivate.post('/employeeRegister', {
                    name,
                    gender,
                    email,
                    mobile,
                    parent,
                    address,
                    educationQualification,
                    aadhaar,
                    bank,
                    ifsc,
                    pan,
                    role: hierarchyLevel
                });
                const res = response?.data;
                setEmployeeId(res?.employeeId);
                notify('success', res?.success);

                setOpenPhotoUpload(true);

            } catch (err) {
                const errorMessage = err?.response?.data?.message || err?.message || 'error fetching server information';
                notify('failed', errorMessage)
            }
            finally {
                setLoading(false);
            }
        }
        setName('');
        setGender('');
        setEmail('');
        setMobile('');
        setParent('');
        setEducationQualification('');
        setAddress('');
        setAadhaar('');
        setPan('');
        setBank('');
        setIfsc('');
        setHierarchyLevel('village_cluster');
        setError('');
    };

    const handlePhoto = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);

            const photo = document.getElementById("photo");
            const fd = new FormData();

            // @ts-ignore
            if (!photo?.files[0]) {
                notify('info', 'Please select image before uploading')
                return
            }

            // @ts-ignore
            const compressedImage = await compressImage(photo?.files[0])
            fd.append('photo', compressedImage);

            const response = await axiosPrivate.post(`/employee/uploadEmployeePhoto/${employeeId}`, fd,
                {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });

            const success = response?.data?.success;
            if (success)
                notify('success', success);

        } catch (err) {
            notify('failed', err?.response?.data?.message);
        } finally {
            setLoading(false);
            setOpenPhotoUpload(false);
        }
    }

    const compressImage = async (file) => {
        const options = {
            maxSizeMB: 0.048,
            maxWidthOrHeight: 600,
            useWebWorker: true,
        };

        const compressedFile = await imageCompression(file, options);
        return compressedFile;
    };

    const validateMobile = (mobile) => {
        const re = /^[0-9]{10}$/;
        return re.test(mobile);
    };

    return (
        <>
            <div className='formContainer'>
                <div className='formWrapper'>
                    <h2 className='formTitle'>Employee Registration Form</h2>
                    {error && <div style={{ color: 'red', marginBottom: '15px', textAlign: 'center' }}>{error}</div>}
                    <form onSubmit={handleSubmit}>

                        <div className='formRow'>
                            <div className='formGroup'>
                                <div className='formGroup'>
                                    <span className='formLabel'>Name</span>
                                    <input
                                        className='formInput'
                                        type="text"
                                        autoFocus
                                        value={name}
                                        onChange={(event) => setName(event.target.value)}
                                        required
                                    />
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>Mobile</span>
                                    <input
                                        className='formInput'
                                        type="tel"
                                        value={mobile}
                                        onChange={(event) => setMobile(event.target.value)}
                                        required
                                    />
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>Gender</span>
                                    <select
                                        className="formInput"
                                        name='gender'
                                        value={gender}
                                        onChange={(event) => setGender(event.target.value)}
                                        required
                                    >
                                        <option value="">select</option>
                                        <option value="male">Male</option>
                                        <option value="female">Female</option>
                                    </select>
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>Parent</span>
                                    <input
                                        className='formInput'
                                        type="text"
                                        value={parent}
                                        onChange={(event) => setParent(event.target.value)}
                                        required
                                    />
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>Education qualification</span>
                                    <input
                                        className='formInput'
                                        type="text"
                                        value={educationQualification}
                                        onChange={(event) => setEducationQualification(event.target.value)}
                                        required
                                    />
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>Address</span>
                                    <input
                                        className='formInput'
                                        value={address}
                                        type="text"
                                        onChange={(event) => setAddress(event.target.value)}
                                        required
                                    />
                                </div>
                            </div>

                            <div className='formGroup'>
                                <div className='formGroup'>
                                    <span className='formLabel'>Email</span>
                                    <input
                                        className='formInput'
                                        type="email"
                                        value={email}
                                        onChange={(event) => setEmail(event.target.value)}
                                        required
                                    />
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>Aadhaar</span>
                                    <input
                                        className='formInput'
                                        type="text"
                                        value={aadhaar}
                                        onChange={(event) => setAadhaar(event.target.value)}
                                        required
                                    />
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>IFSC</span>
                                    <input
                                        className='formInput'
                                        type="text"
                                        value={ifsc}
                                        onChange={(event) => setIfsc(event.target.value)}
                                        required
                                    />
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>Pan</span>
                                    <input
                                        className='formInput'
                                        type="text"
                                        value={pan}
                                        onChange={(event) => setPan(event.target.value)}
                                        required
                                    />
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>Bank account number</span>
                                    <input
                                        className='formInput'
                                        type="text"
                                        value={bank}
                                        onChange={(event) => setBank(event.target.value)}
                                        required
                                    />
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>Hierarchy level</span>
                                    <select
                                        className="formInput"
                                        name='hierarchy'
                                        value={hierarchyLevel}
                                        onChange={(event) => setHierarchyLevel(event.target.value)}
                                        required
                                    >
                                        {HIERARCHY_LEVELS
                                            .filter(h => ROLE_LEVEL[h.value] < ROLE_LEVEL[role])
                                            .map(h => <option value={h.value}>{h.label}</option>)}
                                    </select>
                                </div>
                            </div>
                        </div>

                        <button className='submitButton' type="submit" disabled={loading}>{loading ? <span className='spinner' /> : 'Register'}</button>

                    </form>
                </div>
            </div>

            <Modal
                isOpen={openPhotoUpload}
                onRequestClose={() => setOpenPhotoUpload(false)}
                style={{
                    overlay: { backgroundColor: "rgba(0,0,0,0.4)" },
                }}
                className='formContainer'
            >
                <div className='formWrapper'>
                    <h2 className='formTitle'>Employee photo upload</h2>
                    <form onSubmit={handlePhoto}>

                        <div className="formGroup">
                            <input
                                className="formInput"
                                type="file"
                                id="photo"
                                name='photo'
                            />
                        </div>
                        <div className="formRow">
                            <button
                                className='close-btn'
                                style={{ width: '95%' }}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setOpenPhotoUpload(false);
                                }}>
                                <span>Close</span>
                            </button>
                            <button className="submitButton"> {loading ? <span className='spinner' /> : 'Upload'}</button>
                        </div>
                    </form>
                </div>

            </Modal >
        </>
    );
}

export default EmployeeRegister;